export const environment = {
  production: false,
  lawLinks: {
    ru: {
      administrativeCode: 'https://adilet.zan.kz/rus/docs/K1400000235',
      criminalCode: 'https://adilet.zan.kz/rus/docs/K1400000226',
      anticorruptionLaw: 'https://adilet.zan.kz/rus/docs/Z1500000410',
    },
    kz: {
      administrativeCode: 'https://adilet.zan.kz/kaz/docs/K1400000235',
      criminalCode: 'https://adilet.zan.kz/kaz/docs/K1400000226',
      anticorruptionLaw: 'https://adilet.zan.kz/kaz/docs/Z1500000410',
    },
  },
};
